import type Model from '@ember-data/model';

export default function getModelClassName(model: Model): string {
  return (<{ modelName: string }>(<unknown>model.constructor)).modelName;
}
